import React, { useState, createContext, useContext } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AIShowcase from './components/AIShowcase';
import CoursesSection from './components/CoursesSection';
import StatsSection from './components/StatsSection';
import ProcessTestimonials from './components/ProcessTestimonials';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import ChatBot from './components/ChatBot';
import DomainsPage from './components/DomainsPage';
import TalkToExpert from './components/TalkToExpert';
import ProjectsListPage from './components/ProjectsListPage';

export const ExpertModalContext = createContext({ open: () => {} });

function HomePage() {
  const { open } = useContext(ExpertModalContext);
  return (
    <div className="min-h-screen font-inter">
      <Navbar onExpertClick={open} />
      <main>
        <HeroSection onExpertClick={open} />
        <ServicesSection />
        <AIShowcase />
        <CoursesSection />
        <StatsSection />
        <ProcessTestimonials />
        <CTASection onExpertClick={open} />
      </main>
      <Footer />
      <ChatBot />
    </div>
  );
}

function App() {
  const [expertOpen, setExpertOpen] = useState(false);
  return (
    <ExpertModalContext.Provider value={{ open: () => setExpertOpen(true) }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/domains" element={<><DomainsPage /><ChatBot /></>} />
          <Route path="/projects" element={<><ProjectsListPage /><ChatBot /></>} />
        </Routes>
        <TalkToExpert isOpen={expertOpen} onClose={() => setExpertOpen(false)} />
      </BrowserRouter>
    </ExpertModalContext.Provider>
  );
}

export default App;
